import React from "react";

/**
 * Bloque de alcance N2 ("¿Qué incluye?").
 */
export function ScopeSidebar({ scope }) {
  return (
    <section className="mb-8 border border-gray-200 bg-white p-6" data-testid="nivel2-scope-block">
      <h2 className="font-serif text-xl text-gray-900 mb-2">¿Qué incluye?</h2>
      <p className="text-sm text-gray-700 mb-4">
        {scope?.description || "Paquete documental precontractual revisado por experto humano."}
      </p>
      <ul className="space-y-3">
        {(scope?.scope_items || []).map((item) => (
          <li key={item.key} className="flex gap-3" data-testid={`scope-item-${item.key}`}>
            <span className="text-primary mt-0.5">✓</span>
            <div>
              <p className="font-medium text-gray-900">{item.label}</p>
              <p className="text-xs text-gray-600">{item.summary}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
